import { MenuItem } from './SideMenuModels';
import {
  FaBookMedical,
  FaClinicMedical,
  FaHandHoldingMedical,
  FaFileContract,
  FaMoneyCheckAlt,
  FaClipboardList,
  FaCommentDollar,
  FaFileMedicalAlt,
  FaHome,
  FaPage4,
  FaRibbon,
  FaRegIdCard,
  FaMoneyBill,
  FaMoneyCheck,
  FaBuilding,
  FaLayerGroup,
  FaAngry,
  FaGitlab,
  FaPersonBooth,
  FaPeopleArrows,
  FaUserFriends,
  FaUserCircle,
  FaUsers,
  FaStudiovinari,
  FaLeanpub,
  FaFileMedical,
  FaUserCheck,
  FaUserGraduate,
  FaUserMd,
  FaNotesMedical,
  FaHandHoldingUsd,
  FaShieldAlt,
  FaBusinessTime,
  FaChartLine,
  FaCog
} from 'react-icons/fa';

export const MenuItems: MenuItem[] = [
  {
    key: 'home',
    icon: <FaHome />,
    name: 'sideMenu.home',
    title: 'Panel principal',
    ariaLabel: '',
    target: '',
    preview: false
  },
  {
    key: 'healthInsurance',
    icon: <FaShieldAlt />,
    name: 'sideMenu.healthInsurance',
    title: 'Add',
    ariaLabel: '',
    target: 'insurances',
    preview: false
  },
  {
    key: 'healthServices',
    icon: <FaBookMedical />,
    name: 'sideMenu.healthServices',
    title: 'Medical Services',
    ariaLabel: '',
    target: 'medicalservices',
    preview: false
  },
  {
    key: 'services',
    icon: <FaClipboardList />,
    name: 'sideMenu.services',
    title: 'Services',
    ariaLabel: '',
    target: 'services',
    preview: false
  },
  {
    key: 'Consultorios',
    icon: <FaClinicMedical />,
    name: 'sideMenu.consultorios',
    title: 'Consultorios',
    ariaLabel: '',
    target: 'offices',
    badge: 'sideMenu.badges.new',
    badgeTone: 'new',
    preview: true
  },
  {
    key: 'Staff',
    icon: <FaUserGraduate />,
    name: 'sideMenu.staff',
    title: 'Staff',
    ariaLabel: '',
    target: 'staff',
    badge: 'sideMenu.badges.new',
    badgeTone: 'new',
    preview: false
  },
  {
    key: 'Practiotioners',
    icon: <FaUserMd />,
    name: 'sideMenu.practitioners',
    title: 'Practitioner',
    ariaLabel: '',
    target: 'practitioners',
    preview: false
  },
  {
    key: 'Providers',
    icon: <FaUserFriends />,
    name: 'sideMenu.providers',
    title: 'Providers',
    ariaLabel: '',
    target: 'Providers',
    preview: false
  },
  {
    key: 'Sponsors',
    icon: <FaUsers />,
    name: 'sideMenu.sponsors',
    title: 'Sponsors',
    ariaLabel: '',
    target: 'sponsors',
    preview: false
  },
  {
    key: 'Protocolos',
    icon: <FaNotesMedical />,
    name: 'sideMenu.protocols',
    title: 'Practitioner',
    ariaLabel: '',
    target: 'protocolsagreements',
    preview: false
  },
  {
    key: 'Contracts',
    icon: <FaFileContract />,
    name: 'sideMenu.contracts',
    title: 'Contracts',
    ariaLabel: '',
    target: 'contracts',
    preview: false
  },
  {
    key: 'Settlements',
    icon: <FaMoneyCheckAlt />,
    name: 'sideMenu.settlements',
    title: 'Settlements',
    ariaLabel: '',
    target: 'settlements',
    preview: false
  },
  {
    key: 'CashFlow',
    icon: <FaHandHoldingUsd />,
    name: 'sideMenu.cashflow',
    title: 'Flujo de caja',
    ariaLabel: '',
    target: 'cashflow',
    preview: false
  },
  {
    key: 'Proyections',
    icon: <FaChartLine />,
    name: 'sideMenu.proyections',
    title: 'Panel Financiero',
    ariaLabel: '',
    target: 'proyections',
    badge: 'sideMenu.badges.preview',
    badgeTone: 'preview',
    preview: false
  },
  {
    key: 'Settings',
    icon: <FaCog />,
    name: 'sideMenu.settings',
    title: 'Configuraciones',
    ariaLabel: '',
    target: 'more-settings',
    badge: 'sideMenu.badges.new',
    badgeTone: 'new',
    preview: true
  }
];

export const MenuItemsOverflow = [
  {
    key: 'item4',
    name: 'Overflow Link 1',
    onClick: undefined
  },
  {
    key: 'item5',
    name: 'Overflow Link 2',
    onClick: undefined
  }
];
